import React from 'react';

export default (props) => <div className="divider" {...props} />;
